import { GraphQLTypes } from "kw/api/zeus";
import { useAPI } from "kw/api/useAPI";
import { useUser } from "kw/auth/useUser";
import { useEffect, useState } from "react";

export const useContactUs = () => {
  const user = useUser();
  const { query } = useAPI();
  const [contactUs, setContactUs] = useState<OrganizationType>(user?.organization);
  useEffect(() => {
    if (!user?.organization) {
      query(
        {
          organization: {
            name: true,
            operatingHours: true,
            emailAddress: true,
            website: true,
            disclaimer: true,
            phoneDisplay: true,
          },
        },
        (response: { organization: GraphQLTypes["OrganizationType"] }) => {
          setContactUs(response.organization);
        }
      );
    }
  }, []);

  return { contactUs };
};
